import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  baseStyle: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    border: '1px dashed #CCCCCC',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    outline: 'none',
    transition: 'border .24s ease-in-out',
  },
  gridMargin: {
    margin: '15px !important',
  },
  acceptedFileStyle: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 10,
    lineHeight: '16px',
    textAlign: 'center',
    color: '#828282',
  },
  contentStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '14px',
    textAlign: 'center',
    color: '#333333',
    width: 330,
  },
  formLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '20px',
    color: '#666666',
    margin: 12,
  },
  emailFormLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 16,
    lineHeight: '24px',
    color: '#333333',
  },
  uploadedFileName: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '20px',
    color: '#666666',
  },
  emailSubtitle: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '28px',
    color: '#333333',
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: '4px 0',
  },
  registeredFile: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    marginLeft: 24,
    color: '#666666',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
  },
  newFile: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    marginLeft: 24,
    color: '#333333',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
  },
  newFileForEmail: {
    marginLeft: '100px',
  },
  downloadButton: {
    color: '#333333',
    padding: '3px',
    cursor: 'pointer',
  },
  removeButton: {
    color: '#DF0C36',
    padding: '3px 0px',
    cursor: 'pointer',
  },
  titleMargin: {
    margin: '6px 0',
  },
  error: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 10,
    lineHeight: '16px',
    textAlign: 'center',
    color: '#DF0C36',
    margin: '0px 8px',
  },
  uploaderErrorBorder: {
    border: '1px dashed #DF0C36 !important',
  },
  paper: {
    width: '610px',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: 0,
    color: '#666666',
  },
  warningIcon: {
    color: '#DF0C36',
    margin: '30px 30px',
  },
  dialogTitle: {
    marginLeft: '15px',
    marginTop: '10px',
  },
  dialogContent: {
    marginLeft: '15px',
    marginRight: '80px',
  },
  dialogActions: {
    marginRight: '80px',
    marginBottom: '40px',
  },
  dialogText: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#333333',
    textAlign: 'justify',
  },
  validateButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    backgroundColor: '#DF0C36',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#B00429',
    },
  },
  cancelButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    color: '#DF0C36',
    borderColor: '#DF0C36',
    borderRadius: 0,
    marginRight: '24px',
    '&:hover': {
      color: '#B00429',
      borderColor: '#B00429',
      backgroundColor: '#FFFFFF',
    },
  },
}));
